<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 16 16">
    <path fill="#040410" fill-opacity=".6" d="M8 1.336a6.669 6.669 0 0 1 6.666 6.667A6.67 6.67 0 0 1 8 14.669a6.67 6.67 0 0 1-6.667-6.666A6.67 6.67 0 0 1 8 1.336ZM4.015 10.28c.979 1.46 2.448 2.39 4.091 2.39 1.643 0 3.113-.93 4.091-2.39a5.979 5.979 0 0 0-4.09-1.61 5.979 5.979 0 0 0-4.092 1.61ZM8 7.336a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/>
  </svg>
</template>
<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'WcIconUserFilled',
  components: {},
  props: {
    color: {
      type: String,
      default: '#ffffff'
    }
  }
})
export default class extends Vue {
  @Prop({ default: '#ffffff' }) color!: String;
}
</script>

<style scoped>
</style>
